import React, { FunctionComponent } from 'react';
import { Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { formLayout } from '~/components/ui';
import { PHONE_NUMBER_PATTERN, PHONE_PREFIX_OPTIONS } from './phonePrefix';
import styles from '../../form/authForm.module.scss';

interface PhoneFieldProps {
  /** Nazwa formularza antd: id pola numeru to `<nazwa>_phoneNumber` (etykieta wskazuje je przez htmlFor). */
  formName: string;
  disabled: boolean;
}

/**
 * Opcjonalny telefon: kierunkowy („PL +48”, z wyszukiwaniem) sklejony z numerem w jedną kontrolkę.
 * Numer bez kierunkowego — tylko cyfry, spacje i myślniki (dawniej pole liczbowe przyjmowało same cyfry).
 * Błąd pola z `noStyle` antd pokazuje pod zewnętrznym Form.Item (z etykietą).
 */
const PhoneField: FunctionComponent<PhoneFieldProps> = ({ formName, disabled }) => {
  const { t } = useTranslation('auth');
  const numberId = `${formName}_phoneNumber`;

  return (
    <Form.Item
      label={
        <>
          {t('auth:screens.field.phone')}
          <span className={formLayout.optional}>{t('auth:screens.field.optional')}</span>
        </>
      }
      htmlFor={numberId}
      required={false}
    >
      <div className={styles.phone}>
        <Form.Item name="phoneCountry" noStyle>
          <Select
            showSearch
            optionFilterProp="label"
            options={PHONE_PREFIX_OPTIONS}
            aria-label={t('auth:screens.field.phonePrefix')}
            popupMatchSelectWidth={false}
            disabled={disabled}
          />
        </Form.Item>
        <Form.Item
          name="phoneNumber"
          noStyle
          rules={[
            { pattern: PHONE_NUMBER_PATTERN, message: t('auth:screens.validation.phoneInvalid') },
          ]}
        >
          <Input type="tel" inputMode="tel" autoComplete="tel-national" readOnly={disabled} />
        </Form.Item>
      </div>
    </Form.Item>
  );
};

export default PhoneField;
